/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Kódy slev nejsou aktuálně k dispozici. Prosím navštivte později nebo se přihlaste k našemu zpravodaji a získejte aktualizace.`
};

const da_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Der er i øjeblikket ingen rabatkoder tilgængelige. Kom tilbage senere eller tilmeld dig vores nyhedsbrev for opdateringer.`
};

const de_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Derzeit sind keine Rabattcodes verfügbar. Bitte schauen Sie später wieder vorbei oder abonnieren Sie unseren Newsletter für Updates.`
};

const en_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Currently, there are no discount codes available. Please check back later or subscribe to our newsletter for updates.`
};

const es_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Actualmente no hay códigos de descuento disponibles. Por favor, vuelve más tarde o suscríbete a nuestro boletín para recibir actualizaciones.`
};

const fr_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun code de réduction n'est disponible actuellement. Veuillez revenir plus tard ou vous abonner à notre newsletter pour recevoir les mises à jour.`
};

const hu_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Jelenleg nincsenek promóciós kódok elérhetők. Kérjük, térj vissza később, vagy iratkozz fel a hírlevelünkre a frissítések megújításához.`
};

const it_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun codice sconto attualmente disponibile. Riprova più tardi o iscriviti alla nostra newsletter per ricevere aggiornamenti.`
};

const nl_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Er zijn momenteel geen kortingscodes beschikbaar. Kom later terug of abonneer je op onze nieuwsbrief voor updates.`
};

const pl_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Obecnie brak dostępnych kodów rabatowych. Odwiedź nas ponownie później lub zapisz się do newslettera, aby otrzymywać aktualizacje.`
};

const pt_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhum código de desconto está disponível no momento. Por favor, volte mais tarde ou assine nossa newsletter para receber atualizações.`
};

const sv_discount_codes_no_codes_description = /** @type {(inputs: {}) => string} */ () => {
	return `Det finns för närvarande inga rabattkoder. Kom tillbaka senare eller prenumerera på vårt nyhetsbrev för uppdateringar.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const discount_codes_no_codes_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.discount_codes_no_codes_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("discount_codes_no_codes_description", locale)
	if (locale === "cs") return cs_discount_codes_no_codes_description(inputs)
	if (locale === "da") return da_discount_codes_no_codes_description(inputs)
	if (locale === "de") return de_discount_codes_no_codes_description(inputs)
	if (locale === "en") return en_discount_codes_no_codes_description(inputs)
	if (locale === "es") return es_discount_codes_no_codes_description(inputs)
	if (locale === "fr") return fr_discount_codes_no_codes_description(inputs)
	if (locale === "hu") return hu_discount_codes_no_codes_description(inputs)
	if (locale === "it") return it_discount_codes_no_codes_description(inputs)
	if (locale === "nl") return nl_discount_codes_no_codes_description(inputs)
	if (locale === "pl") return pl_discount_codes_no_codes_description(inputs)
	if (locale === "pt") return pt_discount_codes_no_codes_description(inputs)
	return sv_discount_codes_no_codes_description(inputs)
};
export { discount_codes_no_codes_description as "discount_codes.no_codes_description" }